import React from 'react';
import { connect } from 'dva';
import styles from './index.css';

const Ad = ({loc, style, ad, auto_hide}) => {
    if (auto_hide && !ad[loc]) return <div />;
    return (
    <div className={styles.ad} style={{
        background: '#e2e2e2',
        ...style
    }}>
        {ad[loc] &&
        <img alt='' src={ad[loc].pic} style={{
            width: '100%', 
            height: '100%', 
        }} onClick={() => window.open(ad[loc].url)}/>
        }
    </div>
    )
}

const state_props = state => {
    return {
        ad: state.ad.data, 
    }
}

export default connect(state_props)(Ad);



// WEBPACK FOOTER //
// ./src/component/ad/index.js